module.exports = __webpack_public_path__ + "static/img/SensorPIR-1.0387a70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/SensorPIR-1.svg
// module id = ZWBI
// module chunks = 0